
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirefdae"];
var parcelRegister = parcelRequire.register;
parcelRegister("cSYPB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9619b6fe2d8cf0f0$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fe6e09ea53e7fa3fa7d8ba2613e2fb7>>
 * @codegenCommand yarn build tokens
 */ var $9619b6fe2d8cf0f0$export$2e2bcd8739ae039 = "\nhtml[data-theme~=\"spacing:spacing\"], [data-subtree-theme][data-theme~=\"spacing:spacing\"] {\n  --ds-space-0: 0rem;\n  --ds-space-025: 0.125rem;\n  --ds-space-050: 0.25rem;\n  --ds-space-075: 0.375rem;\n  --ds-space-100: 0.5rem;\n  --ds-space-150: 0.75rem;\n  --ds-space-200: 1rem;\n  --ds-space-250: 1.25rem;\n  --ds-space-300: 1.5rem;\n  --ds-space-400: 2rem;\n  --ds-space-500: 2.5rem;\n  --ds-space-600: 3rem;\n  --ds-space-800: 4rem;\n  --ds-space-1000: 5rem;\n  --ds-space-negative-025: -0.125rem;\n  --ds-space-negative-050: -0.25rem;\n  --ds-space-negative-075: -0.375rem;\n  --ds-space-negative-100: -0.5rem;\n  --ds-space-negative-150: -0.75rem;\n  --ds-space-negative-200: -1rem;\n  --ds-space-negative-250: -1.25rem;\n  --ds-space-negative-300: -1.5rem;\n  --ds-space-negative-400: -2rem;\n}\n";

});


//# sourceMappingURL=atlassian-spacing.7398006b.js.map
